import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Input, Button, Select, Radio, DatePicker } from 'antd';
import Draggable from 'react-draggable';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import SelectCenter from "../util/SelectCenter";
import { confirmAlert } from 'react-confirm-alert';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from  "react-datepicker";
import ko from 'date-fns/locale/ko';
import { useSelector } from 'react-redux';
import moment from 'moment';
import setup from '../setup';
import GetApiHost from './GetApiHost';
registerLocale('ko', ko)

const { Option } = Select;
const layout = {
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 12,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 8,
        span: 16,
    },
};

function ReservationPopup(props) {
    const [cid, setCid] = useState('');
    const [selectedCenter, setSelectedCenter] = useState('');
    const [title, setTitle] = useState('');
    const [hourConfig, setHourConfig] = useState([]);
    const data = useSelector(state => state.data);
    const [form] = Form.useForm();

    function handleSelectedCenter(cid){
        setSelectedCenter(cid);
        form.setFieldsValue({
            cid: cid
        });
    }

    const getHourConfig = () => {
        (async function () {
            const host = GetApiHost();
            const result = await axios.post(host + '/gympass_admin/get_hour_config', {})
            setHourConfig(result.data.rows);
        })();

    }

    const onFinish = (values) => {
        const { cid, class_date, class_hour_seq, state } = values;
        let format_class_date = moment(class_date).format('YYYY-MM-DD');
        (async function () {
            const host = GetApiHost();
            const result = await axios.post(host + '/gympass_admin/edit_reservation', {
                seq : props.data.seq,
                cid : cid,
                class_date : format_class_date,
                class_hour_seq : class_hour_seq,
                state : state
            })
            if(result.data.ret == 'Y'){
                alert('수정되었습니다');
                props.closePopup("updated");
            }else{
                alert(result.data.msg)
            }
        })();
    }

    async function deleteReservation(seq) {
        const host = GetApiHost();
        const result = await axios.post(host + '/gympass_admin/delete_reservation', {
            seq : seq
        })
        if(result.data.ret == 'Y'){
            alert('삭제되었습니다');
            props.closePopup("updated");
        }else{
            alert(result.data.msg)
        }
    }

    async function absentReservation(seq) {
        const host = GetApiHost();
        const result = await axios.post(host + '/gympass_admin/absent_reservation', {
            seq : seq
        })
        if(result.data.ret == 'Y'){
            alert('결석처리되었습니다');
            props.closePopup("updated");
        }else{
            alert(result.data.msg)
        }
    }

    function handleDelete() {
        confirmAlert({
            title: '삭제 확인',
            message: props.data.name + "님의 예약를 삭제하시겠습니까?",
            buttons: [
              {
                label: 'Yes',
                onClick: () => deleteReservation(props.data.seq)
              },
              {
                label: 'No'
              }
            ]
          });
    }

    function handleAbsent() {
        confirmAlert({
            title: '결석 처리 확인',
            message: props.data.name + "님의 예약를 결석처리하시겠습니까?",
            buttons: [
              {
                label: 'Yes',
                onClick: () => absentReservation(props.data.seq)
              },
              {
                label: 'No'
              }
            ]
          });
    }

    useEffect(()=>{
        setTitle("예약 수정");
        setCid(props.data.cid);
        if(props.mode === "board"){
            form.setFieldsValue({
                class_date : moment(props.data.class_date),
                state : props.data.state,
                class_hour_seq : props.data.class_hour_seq
            });
        }else if(props.mode === "edit"){
            form.setFieldsValue({
                class_date : moment(props.data.class_date_time.substring(0,10)),
                state : props.data.state,
                class_hour_seq : props.data.class_hour_seq
            });
        }else{
            alert("정상적인 접근이 아닙니다.")
        }
        getHourConfig()
    },[]);

    return(
        <div className="popup">
            <Draggable handle=".handle">
            <div className="popupInner">
            <div className="handle">
            <h3>{title}</h3>
            <FontAwesomeIcon icon={faTimes} onClick={() => props.closePopup("")} className="closeIcon" />
            </div>
            <Form {...layout} form={form} onFinish={onFinish}>
            <Form.Item
                name="cid"
                label="센터명"
            >
                <SelectCenter onSelectedCenter={handleSelectedCenter} defaultValue={cid} width="w-100"/>
            </Form.Item>
            <Form.Item name="class_date" label="수업일자">
                <DatePicker />
            </Form.Item>
            <Form.Item name="class_hour_seq" label="수업시간">
                <Select>
                    {
                        hourConfig.map((item, index) => {
                            return(
                                <Option value={item.seq} key={index}>{item.value}</Option>
                            )
                        })
                    }
                </Select>
            </Form.Item>
            <Form.Item label="강사명">
                {props.data.teacher}
            </Form.Item>
            <Form.Item label="고객명">
                {props.data.name}
            </Form.Item>
            <Form.Item name="state" label="상태">
                {props.data.final_state}
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button danger onClick={handleAbsent}>결석</Button>
                &nbsp;
                <Button type="primary" htmlType="submit">수정</Button>
                &nbsp;
                <Button type="danger" onClick={handleDelete}>삭제</Button>
            </Form.Item>
            </Form>
            </div>
            </Draggable>
        </div>
    )
}

export default ReservationPopup;
